import styled, { css } from 'styled-components';

interface RowProps {
  isSpacedBetween?: boolean;
  isAlignedCenter?: boolean;
  hasMargin?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
`;

export const ListWrapper = styled.div``;

export const InputContainer = styled.div`
  position: relative;
  align-items: center;
`;

export const FilterButton = styled.button`
  z-index: 9;
  position: absolute;
  top: 9px;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #004f92;
  border: none;
  border-radius: 100%;
  cursor: pointer;

  transition: all 0.15s ease-in-out;

  &:hover {
    opacity: 0.85;
  }
`;

export const Row = styled.div<RowProps>`
  ${({ isSpacedBetween, isAlignedCenter, hasMargin }) => css`
    display: flex;
    justify-content: ${isSpacedBetween ? 'space-between' : 'initial'};
    align-items: ${isAlignedCenter ? 'center' : 'initial'};
    ${hasMargin &&
    css`
      margin-bottom: 25px;
    `}
  `}
`;

export const ResultText = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: #898b8e;
`;

export const EmptyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 40px;

  p {
    width: 70%;
    font-size: 16px;
    font-weight: 500;
    color: #898b8e;
    margin-top: 16px;
    text-align: center;
  }
`;
